<div class="authorized-users-modal-body">
  <ziro-select data-automation="search-term" [fieldId]="'searchTerm'" [inlineLabel]="false"></ziro-select>

  @if (localUsers().length) {
    <ul class="list-unstyled mt-3 mb-0">
      @for (user of localUsers(); track user.guid) {
        <li>
          <div
            class="card mb-2 px-3 d-flex align-items-center flex-row justify-content-between"
            [attr.data-automation]="'authorized-user-row-' + user.guid"
          >
            <div class="d-flex gap-2 py-2 align-items-center">
              @if (user.photoBase64) {
                <img [src]="'data:image/png;base64,' + user.photoBase64" class="authorized-user-pic" />
              } @else {
                <span class="initials initials-letterspacing-2">
                  <strong>{{ getUserInitials(user.displayName) }}</strong>
                </span>
              }
              <div class="flex-grow-1 d-flex flex-column justify-content-center">
                <p class="mb-0">
                  <strong>{{ user.displayName }}</strong>
                </p>
                <p class="mb-0 text-muted small">{{ user.upn }}</p>
              </div>
            </div>
            <button
              [attr.data-automation]="'remove-authorized-user-' + user.guid"
              class="btn-close close-button"
              (click)="removeUser(user.guid)"
            ></button>
          </div>
        </li>
      }
    </ul>
  } @else {
    <p class="text-muted small mt-3 mb-0">
      {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.authorized_users.no_users_configured' | translate }}
    </p>
  }
</div>
